import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { toast } from '@/lib/v2/components';

import { useService } from '@/src/infrastructure/Protocol/useEmblue';

export const useGroup = () => {
  const service = useService();
  const { t } = useTranslation();

  /** DON’T REPLICATE CODE LIKE THIS, THE NEXT COPY AND PASTE, PLEASE REFACTOR */
  const createGroup = useCallback(
    async (value: string) => {
      const responseCreate = await service?.createGroup(value);
      const OkBody = t('MANAGE_GROUP_MODAL.NOTIFICATION.OkBody');
      let alertBody = t('MANAGE_GROUP_MODAL.NOTIFICATION.KoBody');
      let result = false;

      if (responseCreate.groupId) {
        result = true;
      } else if (responseCreate.errorByName) {
        alertBody = t('MANAGE_GROUP_MODAL.NOTIFICATION.ExistingBody');
      } else if (responseCreate.errorByLimit) {
        alertBody = t('MANAGE_GROUP_MODAL.NOTIFICATION.LimitBody');
      } else {
        alertBody = t('MANAGE_GROUP_MODAL.NOTIFICATION.KoBody');
      }

      if (result) service?.incrementLastRefreshGroupsValue();

      toast({
        title: result
          ? t('MANAGE_GROUP_MODAL.NOTIFICATION.OkTitle')
          : t('MANAGE_GROUP_MODAL.NOTIFICATION.AlertTitle'),
        body: result ? OkBody : alertBody,
        variant: result ? 'success' : 'error',
      });

      return result;
    },
    [service, t]
  );

  return { createGroup };
};
